import API_CONFIG from "../config/axiosConfig";
import { handleResponse } from "../config/axiosUtils";
import axios from "axios";

export async function request(method) {
  const url = `${API_CONFIG.baseUrl}/company/onboarding_preferences`;

  try {
    const response = await axios({
      method,
      url,
      headers: {
        ...API_CONFIG.headers,
      },
    });

    return handleResponse(response);
  } catch (error) {
    throw error;
  }
}
